export const getIsAuthenticated = (state) => !!state.auth?.token ?? false
export const getToken = (state) => state.auth.token
export const getDadosUsuario = (state) => state?.auth?.usuario
export const getEmpresaUsuario = (state) => state.auth?.usuario?.empresa
export const getPaisEmpresa = (state) => state.auth?.usuario?.empresa?.pais
export const getTipoUsuarioLogado = (state) => (
  state.auth?.usuario?.tipoUsuarioId || state.auth?.usuario?.tipoUsuario?.id)
